import { MenuItem } from './menu.model';
//menu Porteur
export const MENUHolder: MenuItem[] = [

    {
        id: 1,
        label: 'Accueil',
        icon: 'uil-home-alt',
        link: '/dashboard',
    },
    //menu porteur
    //{
    // id: 2,
    // label: 'Historique',
    // icon: 'uil-shutter-alt',
    // subItems: [
    {
        id: 2,
        label: 'Transactions',
        //parentId: 64,
        icon: 'uil-exchange-alt',
        link: '/history/transaction',

    },
    {
        id: 3,
        label: 'Transfert',
        icon: 'uil-repeat',
        link: '/history/transfert',
        // parentId: 64,
    },
    {
        id: 4,
        label: 'Recharge Carte',
        icon: 'bx bx-credit-card',
        link: '/history/rechargeCarte',
        //  parentId: 64,
    },

    // {
    //     id: 8,
    //     label: 'Gestion des porteurs',
    //     icon: 'uil-users-alt',
    //     subItems: [
    //         {
    //             id: 9,
    //             label: 'Porteurs Actifs',
    //             icon: 'uil-user-plus',
    //             link: '/history/porteurActif',
    //             parentId: 8
    //         },
    //         {
    //             id: 10,
    //             label: 'Porteurs Inactifs',
    //             icon: 'uil-user-minus',
    //             link: '/history/porteurInactif',
    //             parentId: 8
    //         },
    //         {
    //             id: 11,
    //             label: 'Porteurs non assignés',
    //             icon: 'uil-user-times',
    //             link: '/history/porteurNonAssigne',
    //             parentId: 8
    //         },

    //     ]
    // },



    // {
    //     id: 77,
    //     label: 'Recharge ',
    //     link: '/history/recharge',
    //     parentId: 64,
    //     icon: 'uil-file-alt',
    // },
    // ],
    //},
    // {
    //     id: 5,
    //     label: 'Mes infos',
    //     link: '/contacts/profile',
    //     parentId: 64,
    //     icon: 'uil uil-user-circle font-size-18 align-middle text-muted me-1',
    // },
    // {
    //     id: 3,
    //     label: 'Liste des cartes',
    //     link: '/history/carte',
    //     parentId: 74,
    //     icon: 'uil-file-alt',

    // },
]


//menu client
export const MENUClient: MenuItem[] =
    [
        {
            id: 1,
            label: 'Accueil',
            icon: 'uil-home-alt',
            link: '/dashboard',
        },
       
        {
            id: 2,
            label: 'Transactions ',
            //parentId: 64,
            icon: 'uil-exchange-alt',
            link: '/history/transaction',
        },
        {
            id: 3,
            label: 'Transfert ',
            icon: 'uil-repeat',
            link: '/history/transfert',
            // parentId: 64,
        },
         
        {
            id: 4,
            label: 'Recharge Carte',
            icon: 'bx bx-credit-card',
            subItems: [
                {
                    id: 5,
                    label: 'Recharge Carte',
                    icon: 'uil-transaction',
                    link: '/history/rechargeCarteEnMass',
                    parentId: 4
                },
                   {
                    id: 6,
                    label: 'Paramètre Plafond Postpayé',
                    icon: 'uil-card-atm',
                    link: '/history/repartirPlafondPS',
                    parentId: 4
                },
                {
                    id: 7,
                    label: 'Historique Recharge Carte',
                    icon: 'uil-window-section',
                    link: '/history/rechargeCarte',
                    parentId: 4
                },
                
              

            ]
        },
        {
            id: 8,
            label: 'Recharge Compte',
            icon: 'bx bx-wallet-alt',
            subItems: [
                {
                    id: 9,
                    label: 'Recharge Compte',
                    icon: 'uil-money-insert',
                    link: '/history/rechargeCompte',
                    parentId: 8
                },    
                {
                    id: 10, 
                    label: 'Historique Recharge Compte',
                    icon: 'uil-window-section',
                     link: '/history/historyrechargeCompte',
                    parentId: 8
                },
                
            ]
     },
        {
            id: 11,
            label: 'Gestion des factures',
            icon: 'uil-clipboard-notes',
            link: '/history/facture',
            // parentId: 64,
        },


        {
            id: 12,
            label: 'Gestion des cartes',
            icon: 'uil-apps',
            link: '/history/carte',
            // parentId: 64,
        },
         {
            id: 13,
            label: 'liste des fichers',
            icon: 'uil-archive',
            link: '/history/SuiviFichiers',
            // parentId: 64,
        },
        {
            id: 14,
            label: 'Mes infos',
            icon: 'uil uil-user-circle ',
            link: '/contacts/profile',
            // parentId: 64,
        },



        {
            id: 15,
            label: 'Gestion des porteurs',
            icon: 'uil-users-alt',
            subItems: [
                {
                    id:16,
                    label: 'Porteurs Actifs',
                    icon: 'uil-user-plus',
                    link: '/history/porteurActif',
                    parentId:15
                },
                {
                    id: 17,
                    label: 'Porteurs Inactifs',
                    icon: 'uil-user-minus',
                    link: '/history/porteurInactif',
                    parentId: 15
                },
                {
                    id: 18,
                    label: 'Porteurs non assignés',
                    icon: 'uil-user-times',
                    link: '/history/porteurNonAssigne',
                    parentId: 15
                },

            ]
        },

        





    ];
